<template>
    <div :class="css.modal" v-if="show">
        <ui-icon :class="css.close" name="close" @click="show = false" />
        <div :class="css.main">
            <div :class="css.steps">
                <div :class="css.header">
                    <div class="text-[16px] leading-[32px] font-bold color-1">{{ vars.steps[step - 1].step }}</div>
                    <div>({{ step }}/4)</div>
                </div>
                <div :class="css.contexts">
                    <p v-for="(context, key) in vars.steps[step - 1].contents" v-html="context" :key="key"></p>
                </div>

                <div :class="css.buttons" class="flex-center">
                    <div :class="css.button" @click="step--" v-show="step > 1">{{ $t("Prev") }}</div>
                    <div :class="css.button" @click="methods.close" v-if="step == 4">{{ $t("Close", 2) }}</div>
                    <div :class="css.button" @click="step++" v-else>{{ $t("Next") }}</div>
                </div>

                <div :class="css.line"></div>
            </div>
            <div :class="css.images">
                <img :src="vars.steps[step - 1].image" />
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
//* 组件库
import { UiIcon } from "various-ui";
//* 组件属性
import { useComposable } from "./src/composable";
//* 样式
import css from "./style/index.module.less";

//* 组合函数
const { refs, vars, methods } = useComposable();
const { show, step } = refs;
const { open } = methods;

//* 组件属性导出
defineExpose({ open: open });
</script>
